module.exports = __webpack_public_path__ + "media/34.3ffb8b13.mp3";